import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Space, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import axiosInstance from '../../../configs';

const CostGroupTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [form] = Form.useForm();

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get('/referensi-finance/groups');
            setData(res.data.data);
        } catch (err) {
            message.error('Gagal mengambil data grup');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleAdd = () => {
        setEditingId(null);
        form.resetFields();
        setModalVisible(true);
    };

    const handleEdit = (record) => {
        setEditingId(record.id_cost_group);
        form.setFieldsValue(record);
        setModalVisible(true);
    };

    const handleDelete = async (id) => {
        try {
            await axiosInstance.delete(`/referensi-finance/groups/${id}`);
            message.success('Grup berhasil dihapus');
            fetchData();
        } catch (err) {
            message.error(err.response?.data?.error || 'Gagal menghapus grup');
        }
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (editingId) {
                await axiosInstance.put(`/referensi-finance/groups/${editingId}`, values);
                message.success('Grup berhasil diperbarui');
            } else {
                await axiosInstance.post('/referensi-finance/groups', values);
                message.success('Grup berhasil dibuat');
            }
            setModalVisible(false);
            fetchData();
        } catch (err) {
            message.error('Gagal menyimpan data');
        }
    };

    const columns = [
        { title: 'ID', dataIndex: 'id_cost_group', width: 60, align: 'center' },
        { title: 'Nama Grup Biaya', dataIndex: 'cost_group_name', ellipsis: true },
        {
            title: 'Aksi',
            key: 'action',
            width: 100,
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Space size="small">
                    <Button icon={<EditOutlined />} size="small" onClick={() => handleEdit(record)} />
                    <Popconfirm title="Hapus grup ini?" onConfirm={() => handleDelete(record.id_cost_group)}>
                        <Button icon={<DeleteOutlined />} size="small" danger />
                    </Popconfirm>
                </Space>
            )
        }
    ];

    return (
        <div>
            <div style={{ marginBottom: 12 }}>
                <Button type="primary" icon={<PlusOutlined />} size="small" onClick={handleAdd}>
                    Tambah Grup
                </Button>
            </div>
            <Table
                dataSource={data}
                columns={columns}
                rowKey="id_cost_group"
                loading={loading}
                size="small"
                scroll={{ x: 400 }}
                pagination={{ pageSize: 10, size: "small" }}
            />
            <Modal
                title={editingId ? "Edit Grup Biaya" : "Tambah Grup Biaya"}
                open={modalVisible}
                onOk={handleOk}
                onCancel={() => setModalVisible(false)}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="cost_group_name"
                        label="Nama Grup"
                        rules={[{ required: true, message: 'Harap isi nama grup' }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default CostGroupTable;
